import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import NewEntityButton from './NewEntityButton';
import { InputField } from '../blocks/edit_blocks';
import { TableScreenWithoutUpdate } from '../blocks/table_block';
import Fetcher from '../common/communicate';
import { PROJECT_PREFIX } from '../const';

const API_ENDPOINT = 'betakeys/';

export default class BetakeysScreen extends React.Component {
    constructor(props) {
        super(props);
        this.refreshState = this.refreshState.bind(this);
        this.removeItemHandler = this.removeItemHandler.bind(this);
        this.state = {
            results: [],
            previous: 'none',
            next: 'none',
            total_pages: 0,
            current_page: 1,
        };
    }

    refreshState() {
        this.setState({ results: [] });
    }

    removeItemHandler(event) {
        if (window.confirm(`Внимание! Вы действительно хотите удалить ${event.currentTarget.dataset.name || ''}?`)) {
            Fetcher(`${API_ENDPOINT + event.currentTarget.id}/keys/`, 'DELETE', this.refreshState);
        }
    }

    columns = [{
        Header: 'Название',
        accessor: 'name',
        Cell: (row) => (
            <div>
                <Link to={`${PROJECT_PREFIX}/betakeys/${row.row.id}/edit`}>
                    {row.row.name}
                </Link>
            </div>
        ),
    }, {
        Header: 'Код',
        accessor: 'code',
        minWidth: 150,
        Cell: (row) => (
            `[beta_keys]${row.value}[/beta_keys]`
        ),
    }, {
        Header: 'Количество Ключей',
        accessor: 'number_of_keys',
        maxWidth: 150,

    }, {
        Header: 'Роздано',
        accessor: 'owned_keys',
        maxWidth: 150,
    }, {
        Header: '',
        accessor: 'id',
        maxWidth: 50,
        Cell: (row) => (
            <div>
                <Link to={`${PROJECT_PREFIX}/betakeys/${row.value}/users`}>
                    <FontAwesomeIcon icon="users" />
                </Link>
            </div>
        ),
    }, {
        Header: '',
        accessor: 'id',
        maxWidth: 40,
        Cell: (row) => (
            <Button size="sm" variant="link" id={row.value} data-name={row.original.name} onClick={this.removeItemHandler}>
                <FontAwesomeIcon id={row.value} icon="trash" />
            </Button>
        ),
    },
    ];

    filterChange(event) {
        this.setState({ filter: event.currentTarget.value });
    }

    render() {
        return (
            <div className="container-fluid">
                <Row className="mb-2">
                    <Col md={12}>
                        <NewEntityButton to="/betakeys/new" />
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        <InputField
                            value={this.state.filter}
                            label="Фильтр"
                            name="filter"
                            onChange={this.filterChange}
                        />
                    </Col>
                </Row>
                <TableScreenWithoutUpdate
                    columns={this.columns}
                    endpoint={API_ENDPOINT}
                    data={this.state}
                />
            </div>
        );
    }
}
